import React, { ReactNode, ReactElement, createContext, useContext } from 'react';

export type AirtameVariants = 'default' | 'informative' | 'positive' | 'warning' | 'error';

export type VariantContextType = {
  variant: AirtameVariants;
};

export const VariantContext = createContext<VariantContextType | undefined>(undefined);

export const useVariantContext = () => {
  const ctx = useContext(VariantContext);
  if (!ctx) {
    throw new Error('Variants Context should be used inside the VariantContextProvider');
  }
  return ctx;
};

type VariantContextProviderProps = { variant: AirtameVariants; children: ReactNode };

export const VariantContextProvider = ({
  variant = 'default',
  children,
}: VariantContextProviderProps): ReactElement => {
  const value: VariantContextType = { variant };

  return <VariantContext.Provider value={value}>{children}</VariantContext.Provider>;
};
